exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#valvesStateLegend .v--modal-box.v--modal{min-height:400px!important;min-width:270px!important}#valvesStateLegend .v-list__tile{height:44px!important}#valvesStateLegend .modal__footer{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f26f90e6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/analysis/modals/ValvesStateLegend.vue
// module id = 1775
// module chunks = 0